import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { KontrolltermineComponent } from './kontrolltermine.component';
import { KontrollterminEditComponent } from './kontrolltermin-edit/kontrolltermin-edit.component';

const routes: Routes = [
  {
    path: '',
    component: KontrolltermineComponent
  },
  {
    path: ':id',
    component: KontrollterminEditComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class KontrolltermineRoutingModule { }

